export enum TEMPLATE_TYPE {
    recover_status = 'recover_status',
    status = 'status',
    actions = 'actions',
    date_range = 'dateRange',
    date = 'date',
    kickoff = 'kickoff',
}
